import ConfirmDialog from './ConfirmDialog';
import { fmtPhone } from '../visitorConstants';

// Unblock takes no request body — the API clears the reason, actor and
// timestamp itself — so there is nothing to collect, only to confirm.
const UnblockVisitorDialog = ({ visitor, busy = false, onConfirm, onCancel }) => (
    <ConfirmDialog
        open={!!visitor}
        title="Unblock visitor?"
        subtitle="They will be allowed at the gate again."
        confirmLabel="Unblock"
        busyLabel="Unblocking..."
        tone="success"
        icon="mdi:lock-open-variant-outline"
        busy={busy}
        onConfirm={onConfirm}
        onCancel={onCancel}
    >
        <p className="tw-mb-0">
            <span className="tw-font-semibold">{visitor?.name}</span> ({fmtPhone(visitor?.phone)}) will be unblocked
            and the recorded reason cleared.
        </p>
    </ConfirmDialog>
);

export default UnblockVisitorDialog;
